import React from 'react'
import Dialog from 'lib/ui/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from 'lib/ui/Button'
import type {BroadcastFormValues} from 'organization/Event/Broadcasts/BroadcastForm'

export default function ConfirmUnpublishBroadcastDialog(props: {
  values: BroadcastFormValues
  onCancel: () => void
  onKeepAsDraft: (values: BroadcastFormValues) => void
  onPublish: (values: BroadcastFormValues) => void
}) {
  const {values, onCancel, onKeepAsDraft, onPublish} = props

  return (
    <Dialog open disableBackdropClick onClose={onCancel}>
      <DialogTitle>Publish this broadcast?</DialogTitle>
      <DialogContent>
        This broadcast is currently published, but the Publish toggle is set to
        Draft. Saving now will unpublish it, and it will not be sent. Would you
        like to publish it, or keep it as a draft?
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          type="button"
          onClick={onCancel}
          aria-label="cancel unpublish"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          type="button"
          onClick={() => onKeepAsDraft(values)}
          aria-label="keep broadcast as draft"
        >
          Keep as Draft
        </Button>
        <Button
          variant="contained"
          color="success"
          type="button"
          onClick={() => onPublish(values)}
          aria-label="publish broadcast"
        >
          Publish
        </Button>
      </DialogActions>
    </Dialog>
  )
}
